import SVG from 'react-inlinesvg';
import cx from 'classnames';

import { Color, Size, SvgIconProps, SvgTheme } from './SvgIcon.types';

const SvgIcon = ({
  src,
  color = Color.PRIMARY,
  size = Size.MEDIUM,
  className,
  dataTestId,
}: SvgIconProps): React.ReactElement => {
  return (
    <SVG src={src} data-test-id={dataTestId} className={cx(SvgTheme.size[size], SvgTheme.color[color], className)} />
  );
};

export default SvgIcon;
